import React, { useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTheme } from "@mui/material/styles";
import logoutImg from "../../assets/img/logoutImg.jpg";

const LogoutDashboard = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  // Function to navigate to the home page
  const goHome = () => {
    navigate('/');
  };

  useEffect(() => {
    // Warn on refresh or back button and redirect to the home page
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = ""; // Show a generic confirmation message
      navigate('/');
    };

    // Attach event listener for page refresh or back button
    window.addEventListener('beforeunload', handleBeforeUnload);

    // Redirect if user navigates back
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = () => {
      navigate('/');
    };

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.onpopstate = null;
    };
  }, [navigate]);

  return (
    <Box
      sx={{
        height: '100vh', 
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        // justifyContent: 'center',
        textAlign: 'center',
        backgroundColor: '#fff', // Light background color
        padding: '20px',
      }}
    >
      {/* Logout Image */}
      <Box
        component="img"
        src={logoutImg}
        alt="Logout Illustration"
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: '20px',
          marginTop:'15vh',
          height: '40vh',
          // width:'50vw',
          // border:'1px solid black'
        }}
      />

      {/* Logged out message */}
      <Typography
        variant="h5" // Made the text slightly smaller
        sx={{
          fontSize: { xs: '1rem', md: '1.5rem' }, // Adjusted font size
          fontWeight: '500',
          color: '#000', // Primary color
          fontFamily: theme.typography.fontFamily,
          // marginBottom: '10px',
          marginBottom:"2vh",
        }}
      >
        Logged Out Successfully!
      </Typography>

      {/* Go Home button */}
      <Button
        variant="contained"
        onClick={goHome}
        sx={{
          padding: '8px 12px', // Adjusted padding
          backgroundColor: '#197BC5', // Updated button color
          borderRadius: '3px',
          fontSize: '0.7rem', // Slightly smaller font size
          fontWeight: '500',
          color: '#fff',
          boxShadow: '0px 4px 10px rgba(25, 123, 197, 0.3)',
          '&:hover': {
            backgroundColor: '#166EA4',
            boxShadow: '0px 6px 15px rgba(22, 110, 164, 0.35)',
          },
        }}
      >
        Go to Home
      </Button>
    </Box>
  );
};

export default LogoutDashboard;
